import "./Calendar.css"; // Import the CSS file for styling
import React, { useState } from "react";
import EventsCalendar from "../../components/EventsCalendar";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { useEffect } from "react";
import { usePostEvent } from "../../hooks/usePostEvent";

//import { demoEvents } from "../../utils/data";

function Calendar() {
  const location = useLocation();
  const navigate = useNavigate();

  const clubID = localStorage.getItem("clubID") || "003";
  const user = localStorage.getItem("user") || null;
  const { logEvent } = usePostEvent(user);

  useEffect(() => {
    logEvent(48, clubID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubID]);

  // 1. If they navigated via the "Full Calendar" link, grab the date from the router state.
  // Otherwise, default to today.
  const initialDate = location.state?.targetDate
    ? location.state.targetDate
    : moment().format("YYYY-MM-DD");

  const [selectedDate, setSelectedDate] = useState(initialDate);

  // 2. Initialize the state exactly like we did in Home.js
  //const [selectedDate, setSelectedDate] = useState(initialDate);
  const [activeFilters, setActiveFilters] = useState([]);

  const handleFilterToggle = (clickedType) => {
    if (clickedType === "All") {
      setActiveFilters([]);
      return;
    }
    setActiveFilters((prevFilters) => {
      if (prevFilters.includes(clickedType)) {
        return prevFilters.filter((type) => type !== clickedType);
      }
      return [...prevFilters, clickedType];
    });
  };

  const storedEvents = JSON.parse(localStorage.getItem("eventsData")) || [];
  const events = storedEvents.map((event) => ({
    ...event,
    start: new Date(event.eventDate),
    end: new Date(event.endDate),
  }));
  //console.log("🚀 ~ Calendar ~ events:", events);

  const filteredEvents =
    activeFilters.length === 0
      ? events
      : events.filter((event) => activeFilters.includes(event.eventType));
  //console.log("🚀 ~ Calendar ~ filteredEvents:", filteredEvents);

  return (
    <Box sx={{ p: 2, mb: 5 }}>
      <Button
        variant="text"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(`/?id=${clubID}`)}
        sx={{ mb: 2, color: "text.secondary" }}
      >
        Back to Home
      </Button>
      <EventsCalendar
        selectedDate={selectedDate}
        activeFilters={activeFilters}
        handleFilterToggle={handleFilterToggle}
        filteredEvents={filteredEvents}
        onDateChange={setSelectedDate}
      />
    </Box>
  );
}

export default Calendar;
